export default "__VITE_ASSET__CONTIEm5__"